import React, { useEffect, useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Button, Card, CardBody, CardTitle, Col, Label, Row } from "reactstrap"
import { Formik, Form, Field, ErrorMessage } from "lib/formik"
import { useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import Spinners from "components/Shared/Spinners"
import { showAlert } from "store/reducers/alertReducer"
import BackButton from "components/Shared/BackButton"
import { editNotificationSchema } from "components/Common/validation"
import Switch from "components/Shared/Switch"
import {
  getPushNotificationDetails,
  updatePushNotification,
} from "store/actions/pushNotificationAction"
import TextError from "components/Shared/TextError"

const initialValues = {
  titleEn: "",
  titleAr: "",
  bodyEn: "",
  bodyAr: "",
  remark: "",
  status: true,
}

const EditAppNotification = () => {
  document.title = "Edit Notification "

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { loading, isLoading, pushNotificationDetails } = useSelector(
    state => state.PushNotifications
  )

  const [formValues, setFormValues] = useState(initialValues)

  useEffect(() => {
    const fetchOldDetails = () => {
      const payload = {
        id,
      }
      dispatch(getPushNotificationDetails(payload))
    }
    fetchOldDetails()
  }, [])

  useEffect(() => {
    if (pushNotificationDetails) {
      const { title, body, type, actionType, status, remark } =
        pushNotificationDetails

      setFormValues(prevVal => ({
        ...prevVal,
        titleEn: title?.en,
        titleAr: title?.ar,
        bodyEn: body?.en,
        bodyAr: body?.ar,
        remark,
        status,
      }))
    }
  }, [pushNotificationDetails])

  const handleOnSubmit = values => {
    const { titleEn, titleAr, bodyEn, bodyAr, remark, status } = values

    const payload = {
      id,
      title: {
        en: titleEn,
        ar: titleAr,
      },
      body: {
        en: bodyEn,
        ar: bodyAr,
      },
      allowedCustomSound: false, //set default false  //field should not be show on form
      sound: "default", // set default value as "default" //field should not be show on form
      remark: remark ? remark : "",
      status: status ? 1 : 0,
    }

    dispatch(updatePushNotification(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          navigate("/app-notifications")
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  if (loading) return <Spinners />

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col lg={12} className="d-block mx-auto">
            <Card>
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <BackButton />
                  Edit App Notification
                </CardTitle>
                <Formik
                  initialValues={formValues}
                  enableReinitialize={true}
                  validationSchema={editNotificationSchema}
                  onSubmit={handleOnSubmit}
                >
                  {({ values, errors, touched, setFieldValue }) => (
                    <Form>
                      <Row className="mb-4">
                        <Col md={6}>
                          <div className="form_field">
                            <label
                              htmlFor="titleEn"
                              className="col col-form-label"
                            >
                              <span className="text-danger">* </span>
                              Title(English)
                            </label>
                            <Field
                              name="titleEn"
                              type="text"
                              id="titleEn"
                              placeholder="Title(English)"
                              className={`form-control ${
                                touched.titleEn && errors.titleEn
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="titleEn" />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form_field">
                            <label
                              htmlFor="titleAr"
                              className="col col-form-label"
                            >
                              <span className="text-danger">* </span>
                              Title(عربي)
                            </label>
                            <Field
                              name="titleAr"
                              type="text"
                              id="titleAr"
                              style={{ direction: "rtl" }}
                              placeholder="Title(عربي)"
                              className={`form-control ${
                                touched.titleAr && errors.titleAr
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="titleAr" />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form_field">
                            <label
                              htmlFor="bodyEn"
                              className="col col-form-label"
                            >
                              <span className="text-danger">* </span>
                              Message(English)
                            </label>
                            <Field
                              as="textarea"
                              id="bodyEn"
                              name="bodyEn"
                              rows={3}
                              placeholder="Message(English)"
                              //   style={{ direction: "rtl" }}
                              className={`form-control ${
                                touched.bodyEn && errors.bodyEn
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="bodyEn" />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form_field">
                            <label
                              htmlFor="bodyAr"
                              className="col col-form-label"
                            >
                              <span className="text-danger">* </span>
                              Message(عربي)
                            </label>
                            <Field
                              as="textarea"
                              id="bodyAr"
                              name="bodyAr"
                              rows={3}
                              placeholder="Message(عربي) "
                              style={{ direction: "rtl" }}
                              className={`form-control ${
                                touched.bodyAr && errors.bodyAr
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="bodyAr" />
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="form_field">
                            <label
                              htmlFor="remark"
                              className="col col-form-label"
                            >
                              remark
                            </label>
                            <Field
                              name="remark"
                              type="text"
                              id="remark"
                              placeholder="Remark"
                              className={`form-control `}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form_field">
                            <label htmlFor="">Status</label>
                            <Switch
                              isChecked={values.status}
                              onClickHandler={() => {
                                setFieldValue("status", !values.status)
                              }}
                            />
                          </div>
                        </Col>
                        <div className="col-12 mt-4">
                          <div className="d-flex align-items-center justify-content-end">
                            <Button
                              type="button"
                              color="secondary"
                              className=" mx-2"
                              onClick={() => navigate(-1)}
                            >
                              Cancel
                            </Button>
                            <Button
                              color="success"
                              type="submit"
                              style={{ width: "fit-content" }}
                              disabled={isLoading}
                            >
                              Save
                            </Button>
                          </div>
                        </div>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default EditAppNotification
